import {
  Dialog,
  Button,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  DialogActions,
  Stack,
  Grid,
  Checkbox,
  CircularProgress,
  Chip,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { changeMode, FleetModeType, selectDrivers, selectCars } from "Redux/fleetSlice";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useDrivers from "Hooks/useDrivers";
import useCars from "Hooks/useCars";
import IRAN_FLAG from "Assets/Images/falg.png";
import { Box } from "@mui/system";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function FleetDialoig() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { mode, selectedDrivers, selectedCars } = useAppSelector((state) => state.fleet);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    dispatch(changeMode(null));
  };

  const { isLoading: driversIsLoading, data: driversData } = useDrivers();
  const { isLoading: carswIsLoading, data: carsData } = useCars();

  // const vf = {
  //   code: "ZXIJDDUBSG",
  //   plaque: "۳۴-ن-۱۵۹-۶۷",
  //   buildYear: 1399,
  //   color: "قهوه ای سیر_متا",
  //   status: "enable",
  //   carBrandModelName: "کوییک دنده ای",
  //   chairNumber: 4,
  //   typetitle: "سواری",
  // };

  const renderCars = () => {
    if (carswIsLoading) {
      return <CircularProgress color="secondary" size={30} />;
    }
    if (carsData && carsData?.length > 0) {
      return (
        <>
          {carsData?.map((car: any) => {
            const plaque = car?.plaque.split("-");
            return (
              <Stack direction="row">
                <Button
                  sx={{
                    border: "1px solid #aaa",
                    p: 1,
                    borderRadius: 1,
                    width: "90%",
                    marginBottom: "15px",
                    justifyContent: "flex-start",
                    backgroundColor: selectedCars.includes(car.code) ? "#b1b1b5" : null,
                    "&:hover": { bgcolor: selectedCars.includes(car.code) ? "#b1b1b5" : null },
                  }}
                  onClick={() => dispatch(selectCars(car.code))}
                >
                  <Stack sx={{ width: "380px" }}>
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: "10px" }}>
                      <Grid item xs={5}>
                        <Grid container justifyContent="space-between" alignItems="center">
                          <Grid
                            item
                            xs={3}
                            className="fa-number"
                            sx={{ border: "1px solid #979797", borderRadius: "5px 0 0 5px" }}
                          >
                            {plaque[0]}
                          </Grid>
                          <Grid item xs={6} className="fa-number" sx={{ border: "1px solid #979797" }}>
                            {plaque[2]} {plaque[1]} {plaque[3]}
                          </Grid>
                          <Grid item xs={3} sx={{ border: "1px solid #979797", borderRadius: "0 5px 5px 0" }}>
                            <img src={IRAN_FLAG} alt="flag" style={{ display: "inline-block" }} />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        {car.code}
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: "10px" }}>
                      <Grid item xs={6}>
                        {car.carBrandModelName}
                      </Grid>
                      <Grid item xs={6}>
                        {car.color}
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid item xs={6} className="fa-number">
                        مدل {car.buildYear}
                      </Grid>
                      <Grid item xs={6}>
                        <Chip
                          label={car.status === "enable" ? "فعال" : "غیرفعال"}
                          style={{ color: car.status === "enable" ? "green" : "red" }}
                        />
                      </Grid>
                    </Grid>
                  </Stack>
                </Button>
                <Checkbox
                  inputProps={{ "aria-label": "Checkbox demo" }}
                  sx={{
                    "&:hover": { bgcolor: "transparent" },
                  }}
                />
              </Stack>
            );
          })}
        </>
      );
    }
    return <Typography align="center">راننده ای برای نمایش وجود ندارد</Typography>;
  };

  const renderDrivers = () => {
    if (driversIsLoading) {
      return <CircularProgress color="secondary" size={30} />;
    }
    if (driversData && driversData?.length) {
      return (
        <>
          {driversData?.map((driver: any) => {
            return (
              <Stack direction="row" sx={{ width: "380px" }}>
                <Button
                  sx={{
                    border: "1px solid #aaa",
                    p: 1,
                    borderRadius: 1,
                    width: "90%",
                    marginBottom: "15px",
                    justifyContent: "flex-start",
                    backgroundColor: selectedDrivers.includes(driver.id) ? "#b1b1b5" : null,
                    "&:hover": { bgcolor: selectedDrivers.includes(driver.id) ? "#b1b1b5" : null },
                  }}
                  onClick={() => dispatch(selectDrivers(driver.id))}
                >
                  <Stack sx={{ width: "100%" }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      {driver.fname} {driver.lname}
                    </Grid>
                  </Stack>
                </Button>
                <Checkbox
                  inputProps={{ "aria-label": "Checkbox demo" }}
                  sx={{
                    "&:hover": { bgcolor: "transparent" },
                  }}
                />
              </Stack>
            );
          })}
        </>
      );
    }
    return <Typography align="center">راننده ای برای نمایش وجود ندارد</Typography>;
  };

  return (
    <>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={mode === "cars"}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modal title
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ margin: "auto" }}>
          {renderCars()}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <TextField id="outlined-basic" label="جستجو" variant="outlined" />
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={mode === "drivers"}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modal title
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ margin: "auto" }}>
          {renderDrivers()}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <TextField id="outlined-basic" label="جستجو" variant="outlined" />
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
